<my-content placeholder="navigation">
  <div class="col-sm-12" style="border-bottom: 1px solid #ccc"></div>

  <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
      <div class="modal-content">
        <div class="modal-header BlueHeader">
          <h4 class="Heading">{{ ModelFor }}</h4>
          <br />
          <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body col-sm-12 form-group">
          <iframe class="modal-frame" [src]="modalURL | safe"></iframe>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid pe-0">
    <div class="table-header-container">
      <div class="table-heading">
        {{ TypeHeader }}
      </div>
      <form [formGroup]="FormSearchNoticeCase" (ngSubmit)="onSearchNoticeCase(FormSearchNoticeCase.value)">
        <div class="d-flex">
          <div class="input-group" >
            <input type="text" placeholder="Search here..." class="table-search-input form-control"
              formControlName="txtSearch" (input)="onSearch($event.target.value)">
            <span class="input-group-btn">
              <button class="btn btn-primary" title="Search">
                <i class="fas fa-magnifying-glass"></i>
              </button>
            </span>
          </div>
          <button class="btn btn-outline-primary mx-2" [routerLink]="'/notice/'+pageType+'/0'" title="Create">
            <i class="fas fa-plus"></i>
          </button>
          <button class="btn btn-outline-primary " title="Advance Search" data-toggle="modal"
            (click)="OpenModal('ndc', '0', 'Filter', 'ReturnAdvanceSearch')" data-target="#ModalPopUP">
            <i class="fas fa-filter"></i>
          </button>
        </div>
      </form>
    </div>
    <div class="card table-container"> 
      <table class="custom-table">
        <thead>
          <tr>
            <th>S.No.</th>
            <th>Ref. No.</th>
            <th>Short Name</th>
            <th>Date</th>
            <th>Type</th>
            <th>Filing Party</th>
            <th>Opposite Party</th>
            <th>Court</th>
            <th>Location</th>
            <th>Manager</th>
            <th>Exposure Amount</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody >
          <app-table-state [loading]="MsgType == 1" [error]="MsgType == 3" [empty]="filteredData?.length == 0" [rows]="filteredData?.length"
            [columns]="13"></app-table-state>
            @if (filteredData?.length > 0) {
              @for (mDtl of filteredData | paginate : { itemsPerPage: pageSize, currentPage: pageNumber }; track $index; let i = $index)
              {
              <tr>
                <td>{{ (i + 1) + (pageNumber - 1) * pageSize }}</td>
                <td>{{ mDtl.refno }}</td>
                <td>{{ mDtl.ShortName }}</td>
                <td class="date" >{{ mDtl.NoticeDt | date: "dd-MM-yyyy" }}</td>
                <td>{{ mDtl.NoticetypeValue }}</td>
                <td>{{ mDtl.fillingParty }}</td>
                <td>{{ mDtl.OppositeParty }}</td>
                <td>{{ mDtl.Court }}</td>
                <td>State : {{ mDtl.State }} <br /> City : {{ mDtl.City }}</td>
                <td>{{ mDtl.ManagerName }}</td>
                <td>{{ mDtl.ExposureAmt }}</td>
                <td>{{ mDtl.Stages }}</td>
                @if (this.RequestFrom == 'update' || this.RequestFrom == 'process') {
                <td>
                  <a target="_blank" class="icon-btn icon-btn-primary text-decoration-none" [routerLink]="'/gnotice/' + TypeHeader + '/' + mDtl.ID">
                    <i class="fa fa-pencil" ></i>
                  </a>
                </td>
                }
                @if (this.RequestFrom == 'DeleteCase') {
                <td>
                  <input [(ngModel)]="mDtl.isSelected" value="{{ mDtl.ID }}" type="checkbox" />
                </td>
                }
                @if (this.RequestFrom == 'DuplicateDelete') {
                <td>
                  <input [(ngModel)]="mDtl.isSelected" value="{{ mDtl.ID }}" type="checkbox" />
                </td>
                }
                @if (RequestFrom == 'UpdateFinalVerdict') {
                <td>
                  <a target="_blank"  class="icon-btn icon-btn-primary text-decoration-none" [routerLink]="'/FinalVerdict/' + mDtl.ID + '/2'">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </a>
                </td>
                }
              </tr>
              }
            }
        </tbody>
      </table>
    </div>

    @if (MsgType == 0) {
      @if (RequestFrom == 'DuplicateDelete') {
        <div class="d-flex justify-content-center my-3">
          <button class="btn btn-danger" (click)="DuplicateRecordDelete()" >Delete</button>
        </div>
      }
      @if (RequestFrom == 'DeleteCase') {
        <div class="d-flex justify-content-center my-3">
          <button class="btn btn-danger" (click)="DeleteCase()" >Delete</button>
        </div>
      }
      <div class="d-flex justify-content-between my-3 w-100">
          <div class="w-50">
            <app-rows-per-page
            [pageSize]="pageSize"
            [total]="totalRecords"
            [pageIndex]="pageNumber"
            (pageSizeChange)="onPageSizeChange($event)">
          </app-rows-per-page>
          </div>
        <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
      </div>
    }
  </div>
</my-content>
<my-content placeholder="main"> </my-content>